import { useAuth } from './use-auth';

export const useStaff = () => {
   const { user } = useAuth();

   const staff = user?.user?.group === 2;

   return staff
};
